import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class PurchaseAcceptanceItemApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'purchaseAcceptanceItem'
  }

}